module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module4-9.8592653b.jpg";